import { useQuery } from '@tanstack/react-query'
import {
  getSecurityStats,
  getRecentLogins,
  getFailedLoginsSummary,
  getUsersMustChangePassword,
} from '../api/security-admin.api'

export function useSecurityStats() {
  return useQuery({
    queryKey: ['admin', 'security', 'stats'],
    queryFn: getSecurityStats,
  })
}

export function useRecentLogins(limit: number = 20) {
  return useQuery({
    queryKey: ['admin', 'security', 'recent-logins', limit],
    queryFn: () => getRecentLogins(limit),
  })
}

export function useFailedLoginsSummary() {
  return useQuery({
    queryKey: ['admin', 'security', 'failed-logins-summary'],
    queryFn: getFailedLoginsSummary,
  })
}

export function useUsersMustChangePassword() {
  return useQuery({
    queryKey: ['admin', 'security', 'users-must-change-password'],
    queryFn: getUsersMustChangePassword,
  })
}
